var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrasil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.5 23C45.5 35.4264 35.4264 45.5 23 45.5C10.5736 45.5 0.5 35.4264 0.5 23C0.5 10.5736 10.5736 0.5 23 0.5C35.4264 0.5 45.5 10.5736 45.5 23Z",
    fill: "#6EA644"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5625 9.5L42.125 23L23.5625 36.5L5 23L23.5625 9.5Z",
    fill: "#FFDB44"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4375 23C31.4375 27.3492 27.9117 30.875 23.5625 30.875C19.2133 30.875 15.6875 27.3492 15.6875 23C15.6875 18.6508 19.2133 15.125 23.5625 15.125C27.9117 15.125 31.4375 18.6508 31.4375 23Z",
    fill: "#0051B5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4453 19.625C15.9594 20.6479 15.6875 21.7922 15.6875 23C23.7875 21.65 28.4845 25.625 29.8204 27.7813C30.6193 26.7372 31.1629 25.4873 31.3577 24.125C26.8577 19.625 19.5411 19.25 16.4453 19.625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrasil);
export default __webpack_public_path__ + "static/media/brasil.8e593008c4debc1d90739b215a69ab8f.svg";
export { ForwardRef as ReactComponent };